<template>
  <DraggableVue
    :model-value="list"
    :ghost-class="ghostClass"
    :drag-class="dragClass"
    :animation="`${animation}`"
    :item-key="itemKey"
    :active-cursor="activeCursor"
    data-test-id="DraggableList"
    @update="(e: any) => emit('change', e)"
  >
    <template #item="{ element, index }">
      <div :key="element.id" :class="itemClass" :data-test-id="`DraggableList_Field-${element.id}`">
        <slot name="item" :element="element" :index="index" />
      </div>
    </template>
  </DraggableVue>
</template>
<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import DraggableVue from 'vuedraggable'

export type DragEventChange<T> = {
  oldIndex: number
  newIndex: number
  element: T
}

export default defineComponent({
  components: { DraggableVue },
  props: {
    list: {
      required: true,
      type: Object as PropType<unknown[]>,
    },
    itemKey: {
      required: true,
      type: String,
    },
    itemClass: {
      required: false,
      type: String,
      default: '',
    },
    ghostClass: {
      required: false,
      type: String,
      default: '',
    },
    dragClass: {
      required: false,
      type: String,
      default: '',
    },
    animation: {
      required: false,
      type: Number,
      default: 150,
    },
    activeCursor: {
      required: false,
      type: String,
      default: 'grabbing',
    },
  },
  emits: {
    change: (_: DragEventChange<unknown>) => true,
  },
  setup(_, { emit }) {
    return { emit }
  },
})
</script>
